// extracted by mini-css-extract-plugin
export var radial_background = "index-module--radial_background--23fiJ";